import { ChatSimContainer } from "./controllers/chatSimContainer";

export const App = () => {
    return <ChatSimContainer />;
};
